import { Col, Container, Form, Row } from "react-bootstrap";
import clsx from "clsx";
import SetOffHistoryTable from "../ESetOff/components/SetOffHistoryTable";
import SubmittedContractItemModal from "../ESetOff/SetOff/modal/SubmittedContractItemModal";
import { React, useEffect, useState } from "react";
import _ from "lodash";
import LoadingOverlay from "../../components/LoadingOverlay";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../selectors/auth";
import * as generalSelectors from "../../selectors/general";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import EIPOHistoryTable from "./components/EIPOHistoryTable";
import { useHistory } from "react-router";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../services/axiosInstance";
import Helper from "../../utils/Helper";
import CustomConfirmationModal from "../../components/CustomConfirmationModal";
import * as ipoActions from "../../action/ipo";

function EIPOHistory({ipoConfig}) {
  const [page, setPage] = useState(1);
  const [viewData, setViewData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [token, setToken] = useState(null);
  const [deleteUrl, setDeleteUrl] = useState("");
  const [confirmationModalShow, setConfirmationModalShow] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const history = useHistory();

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const ipoHistoryData = useQuery({
    queryKey: ["ipoHistoryData", { page, status, dateFrom, dateTo }],
    queryFn: async () => {
      try {
        const dateQuery =
          !_.isEmpty(dateFrom) && !_.isEmpty(dateTo)
            ? `&transaction_date_from=${dateFrom}&transaction_date_to=${dateTo}`
            : "";
        const statusQuery = !_.isEmpty(status) ? `&status=${status}` : "";
        return await axiosInstance.get(
          `/clientarea/ipo/subscription?page=${page}${statusQuery}${dateQuery}`,
        );
      } catch (e) {
        Helper.handleHttpError(e, dispatch);
      }
    },
    retryDelay: 15000,
    enabled:
      !_.isEmpty(token) &&
      ((!_.isEmpty(dateFrom) && !_.isEmpty(dateTo)) ||
        (_.isEmpty(dateFrom) && _.isEmpty(dateTo))),
  });

  const date = new Date();
  const statusOptions = _.get(ipoConfig,['subscriptionStatus'],[]);

  const dateNow = date.toISOString().split("T")[0];

  const onClickView = (id) => {
    history.push(`/dashboard/e-ipo/history/${id}`);
  };

  const onClickDelete = async (url) => {
    setConfirmationModalShow(true);
    setDeleteUrl(url);
  };

  const onConfirm = async () => {
    setLoading(true);
    try {
      const result = await axiosInstance.del(`${deleteUrl}`);
      await ipoHistoryData.refetch();
      dispatch(ipoActions.removeIpoConfig());

      return result;
    } catch (e) {
    } finally {
      setLoading(false);
      setConfirmationModalShow(false);
      setDeleteUrl("");
    }
  };

  return (
    <Container fluid>
      <div className={clsx("custom-card-label-container text-center")}>
        <h2>IPO History</h2>
      </div>
      <div className={"primary-border-table-border"}>
        <div className="py-3">
          <div className={clsx("custom-table-info-container padding-12px")}>
            <Row>
              <Col xl={2} lg={3} md={4} sm={6} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="formLabel">Status</Form.Label>
                  <Form.Select
                    className="formControl"
                    style={{ height: "100%" }}
                    onChange={(e) => setStatus(e.target.value)}
                    value={status}
                  >
                    <option value={null}>All</option>
                    {_.map(statusOptions, (item, index) => (
                      <option key={index} value={item.value}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xl={2} lg={3} md={4} sm={6} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="formLabel">Date From</Form.Label>
                  <Form.Control
                    min='2025-04-01'
                    max={dateTo || dateNow}
                    onChange={(e) => setDateFrom(e.target.value)}
                    value={dateFrom}
                    className="formControl"
                    name="date_from"
                    type="date"
                  />
                </Form.Group>
              </Col>
              <Col xl={2} lg={3} md={4} sm={6} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label className="formLabel">Date To</Form.Label>
                  <Form.Control
                    max={dateNow}
                    min={dateFrom}
                    onChange={(e) => setDateTo(e.target.value)}
                    value={dateTo}
                    className="formControl"
                    name="date_to"
                    type="date"
                  />
                </Form.Group>
              </Col>
            </Row>
            <EIPOHistoryTable
              onClickDelete={onClickDelete}
              onClickView={onClickView}
              data={ipoHistoryData}
              page={page}
              setPage={setPage}

            ></EIPOHistoryTable>
          </div>
          <LoadingOverlay loading={loading}></LoadingOverlay>
        </div>
      </div>
      <CustomConfirmationModal
        show={confirmationModalShow}
        title="Confirmation"
        desc="Are you sure you want to cancel this item?"
        confirm={onConfirm}
        loading={loading}
        handleClose={() => setConfirmationModalShow(false)}
      />
    </Container>
  );
}

export default EIPOHistory;
